export default __webpack_public_path__ + "static/media/access.6277476b.svg";